import { useMemo } from 'react';
import { useInfiniteVersions } from '../../hooks/useInfiniteVersions';
import { versionService } from '../../services/versionService';
import { ReleaseGroup } from './ReleaseGroup';
import { FormErrorAlert } from '../ui/FormErrorAlert';

interface ReleaseListProps {
  readonly highlightVersionCode?: string;
}

export function ReleaseList({ highlightVersionCode }: ReleaseListProps) {
  const { versions, loading, hasMore, error, loadMore } = useInfiniteVersions();

  const releaseGroups = useMemo(
    () => versionService.groupByVersionCode(versions),
    [versions]
  );

  if (error) return <FormErrorAlert error={error} />;

  if (!loading && releaseGroups.size === 0) {
    return (
      <p className="text-sm text-gray-500 text-center py-4">
        Aún no hay versiones registradas.
      </p>
    );
  }

  return (
    <div className="space-y-0">
      {[...releaseGroups.entries()].map(([versionCode, versions]) => (
        <ReleaseGroup
          key={versionCode}
          versionCode={versionCode}
          versions={versions}
          highlighted={highlightVersionCode === versionCode}
        />
      ))}

      {hasMore && (
        <button
          onClick={loadMore}
          disabled={loading}
          className="w-full mt-4 py-2 text-sm text-blue-600 hover:text-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Cargando...' : 'Cargar más versiones'}
        </button>
      )}

      {loading && releaseGroups.size === 0 && (
        <div className="py-4 text-center">
          <div className="inline-block w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>
      )}

    </div>
  );
}
